<template>
  <base-button type="secondary" size="xs" :circle="true" :circleRadius="40" @click="assign(todoItem.todoItemId)">
    <avatar v-if="hasAvatar === true" :userId="todoItem.assignedToUserId" avatarType="user" :height="40" :width="40" :has-avatar.sync="hasAvatar" />
    <user-icon class="tw-h-full tw-w-full" v-else-if="todoItem.assignedToUserId === null" />
    <span v-else>
      {{ getUser(todoItem.assignedToUserId) }}
    </span>
  </base-button>
</template>
<script>
import Avatar from "@/components/Avatar.vue";
import { UserIcon } from "@/assets/svgs";
export default {
  name: "AssignedUserButton",
  components: { Avatar, UserIcon },
  props: { todoItem: Object, businessUsers: Array },
  data() {
    return {
      hasAvatar: true,
    };
  },
  methods: {
    assign(todoItemId) {
      this.$emit("assign", todoItemId);
    },
    getUser(userId) {
      if (userId && this.businessUsers.length > 0) return this.businessUsers.find((u) => u.userId === userId).initials;
      else return "";
    },
  },
};
</script>
